<mat-toolbar color="primary">
    <img src="assets/img/udg_blanc_transparent_small.png" class="pre-titol-logo">
    <span i18n="@@90ae0645ce3c74b70e7cfb7260d9f70593d690c8">Trasllat</span>&nbsp;-&nbsp;<span>{{oferta.name}}</span>    
    <span class="pre-spacer"></span>
    <div class="button-row">
        <a mat-button href="" target="_self" style="min-width: 10px" i18n>SORTIR</a>
    </div>              
</mat-toolbar>



// WEBPACK FOOTER //
// ./src/app/header/header.component.html